// import React from "react";
import "./EventOneTestimonial.scss";

const testimonial = () => {
  return (
    <div className="event-one-testimonial-outer-div">
      <div className="event-one-testimonial-inner-div">
        <p id="event-one-testimonial-italic">Testimonials</p>
        <h2 id="event-one-testimonial-main-heading">
          What People Say About Us
        </h2>
        <div className="event-one-testimonial-cards-div">
          <div className="event-one-testimonial-card">
            <img
              src="./assets/img/eventify/profile-image.jpeg"
              alt=""
              id="card-image"
            />
            <p id="card-para">
              "The player stats and match previews help me win my fantasy league
              every season. Love the insights!"
            </p>
            <h5 id="card-big-heading">John M, Football Fan</h5>
            <h7 id="card-small-heading">USA</h7>
          </div>

          <div className="event-one-testimonial-card">
            <img
              src="./assets/img/eventify/athlete3.jpeg"
              alt=""
              id="card-image"
            />
            <p id="card-para">
              "I love the clean design and fast updates. Its the perfect mix of
              stats and storytelling—ideal for writing my own blogs."
            </p>
            <h5 id="card-big-heading">Priya K, Sports Blogger</h5>
            <h7 id="card-small-heading">India</h7>
          </div>

          <div className="event-one-testimonial-card">
            <img
              src="./assets/img/eventify/athlete5.jpeg"
              alt=""
              id="card-image"
            />
            <p id="card-para">
              "I never miss a Grand Slam update! The site coverage is spot-on,
              with great commentary and video highlights."
            </p>
            <h5 id="card-big-heading">Sarah T, Tennis Enthusiast</h5>
            <h7 id="card-small-heading">Australia</h7>
          </div>

          <div className="event-one-testimonial-card">
            <img
              src="./assets/img/eventify/athlete1.jpeg"
              alt=""
              id="card-image"
            />
            <p id="card-para">
              "The training tips and strategy breakdowns have helped my team
              improve. A brilliant resource for both fans and professionals."
            </p>
            <h5 id="card-big-heading"> Marcus L, High School Coach</h5>
            <h7 id="card-small-heading">UK</h7>
          </div>
        </div>
      </div>
    </div>
  );
};

export default testimonial;
